/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Grid } from '@mui/material';
import InputField from '../../../Components/InputField';

export default function FormPrompt({
  params: { fields = [] },
}) {
  return (
    <Grid item xs={12} mt={4}>
      <Grid container spacing={2}>
        {fields.map((field) => (
          <InputField key={field.name} {...field} />
        ))}
      </Grid>
    </Grid>
  );
}
